// src/pages/TermsPage.js
import "./auth.css"; // reuse the existing auth styling
import olympeakLogo from "../assets/olympeak_logo_new.png";

const authBg = "/images/olympeak_visual_1.png";

export default function TermsPage() {
  return (
    <div
      className="page-wrapper auth-bg"
      style={{ backgroundImage: `url(${authBg})` }}
    >
      <div className="page-container auth-container privacy-container">
        <div className="app-card auth-card privacy-card">
          <div className="auth-brand">
            <a href="/" className="auth-logo-link">
              <img
                src={olympeakLogo}
                alt="Olympeak"
                className="auth-brand-logo"
              />
            </a>
          </div>

          <div className="auth-form privacy-form">
            <div className="privacy-header">
              <h1 className="privacy-title">Terms of Service</h1>
              <div className="privacy-updated">Last updated: 20 Dec 2025</div>
            </div>

            <div className="privacy-body">
              <p className="privacy-lead">
                These Terms of Service (“Terms”) govern your access to and use
                of Olympeak (“Olympeak”, “we”, “us”, “our”), including our
                website, app, and related services (the “Service”). By using the
                Service, you agree to these Terms.
              </p>

              <h2>1) Who we are</h2>
              <p>
                Olympeak is operated by the business identified on the About
                page. If you have questions, contact us at{" "}
                <a className="app-link" href="mailto:tomanka.filip@gmail.com">
                  tomanka.filip@gmail.com
                </a>{" "}
                (we’ll later replace this with a support email).
              </p>

              <h2>2) Eligibility</h2>
              <p>
                You must be able to form a legally binding contract to use the
                Service. If you are under the age of majority in your country,
                you may use the Service only with permission from a parent or
                legal guardian.
              </p>

              <h2>3) The Service (what we provide)</h2>
              <p>
                Olympeak helps you plan, log, and review workouts and progress.
                The Service is free to use at this time and may include
                features such as workout tracking, analytics, reminders, and
                motivational content. We may update, change, suspend, or
                discontinue parts of the Service at any time.
              </p>

              <h2>4) Not medical advice</h2>
              <p>
                The Service provides general fitness and informational tools
                only. It is not medical advice and is not a substitute for
                professional healthcare guidance. Always consult a qualified
                professional before starting a new exercise program—especially
                if you have any medical conditions, injuries, or concerns.
              </p>
              <p className="hint">
                If you feel pain, dizziness, or discomfort during exercise, stop
                immediately and seek appropriate advice.
              </p>

              <h2>5) Accounts and security</h2>
              <ul>
                <li>
                  You are responsible for maintaining the confidentiality of
                  your account credentials.
                </li>
                <li>
                  You agree to provide accurate information and keep it updated.
                </li>
                <li>
                  You are responsible for activity that occurs under your
                  account.
                </li>
              </ul>

              <h2>6) Acceptable use</h2>
              <p>You agree not to:</p>
              <ul>
                <li>Use the Service for unlawful or harmful purposes.</li>
                <li>
                  Attempt to gain unauthorized access to accounts, systems, or
                  data.
                </li>
                <li>
                  Interfere with the Service (e.g., scraping, overload, reverse
                  engineering, probing vulnerabilities).
                </li>
                <li>
                  Upload or transmit malicious code, spam, or abusive content.
                </li>
                <li>
                  Impersonate others or misrepresent your affiliation.
                </li>
              </ul>

              <h2>7) Your content and data</h2>
              <p>
                You retain ownership of the content you input into the Service
                (e.g., workout logs, notes). You grant us a limited license to
                host, store, and process that content to operate and improve the
                Service.
              </p>
              <p>
                For privacy details, see our{" "}
                <a className="app-link" href="/privacy">
                  Privacy Policy
                </a>
                .
              </p>

              <h2>8) Intellectual property</h2>
              <p>
                The Service, including its design, logos, code, and features, is
                owned by Olympeak or its licensors and is protected by
                intellectual property laws. You may not copy, modify, distribute,
                or create derivative works from the Service except where allowed
                by law.
              </p>

              <h2>9) Free service, ads, and future changes</h2>
              <p>
                The Service is currently offered free. We may introduce optional
                paid features, limits, or advertising in the future. If we do,
                we’ll update these Terms and (where appropriate) notify you.
              </p>

              <h2>10) Third-party services</h2>
              <p>
                The Service may integrate with third-party services (for
                example, authentication providers, email providers, analytics if
                enabled). We are not responsible for third-party services and
                their terms and privacy practices apply.
              </p>

              <h2>11) Availability and changes</h2>
              <p>
                We aim to keep the Service available and reliable, but we do not
                guarantee it will be uninterrupted or error-free. We may perform
                maintenance, updates, or emergency changes at any time.
              </p>

              <h2>12) Termination</h2>
              <p>
                You may stop using the Service at any time. We may suspend or
                terminate access if we reasonably believe you violated these
                Terms or if needed to protect the Service, users, or comply with
                law.
              </p>

              <h2>13) Disclaimers</h2>
              <p>
                The Service is provided on an “as is” and “as available” basis.
                To the extent permitted by law, we disclaim warranties of
                merchantability, fitness for a particular purpose, and
                non-infringement.
              </p>

              <h2>14) Limitation of liability</h2>
              <p>
                To the extent permitted by law, Olympeak will not be liable for
                indirect, incidental, special, consequential, or punitive
                damages, or any loss of profits, data, goodwill, or use.
              </p>
              <p className="hint">
                Nothing in these Terms limits liability that cannot be excluded
                under applicable law.
              </p>

              <h2>15) Indemnity</h2>
              <p>
                You agree to indemnify and hold harmless Olympeak from claims,
                damages, losses, and expenses arising from your misuse of the
                Service or violation of these Terms.
              </p>

              <h2>16) Governing law</h2>
              <p>
                These Terms are governed by the laws of the country where the
                operator of Olympeak is established, unless mandatory consumer
                protection laws in your jurisdiction require otherwise.
              </p>

              <h2>17) Changes to these Terms</h2>
              <p>
                We may update these Terms from time to time. If changes are
                material, we will take reasonable steps to notify you (for
                example, via the Service). Continued use after updates means you
                accept the updated Terms.
              </p>

              <h2>18) Contact</h2>
              <p>
                Questions about these Terms? Contact us at:{" "}
                <a className="app-link" href="mailto:tomanka.filip@gmail.com">
                  tomanka.filip@gmail.com
                </a>
              </p>
            </div>

            <div className="privacy-footer">
              <a className="btn" href="/">
                Back to home
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}